import { render, staticRenderFns } from "./DrugQueue.vue?vue&type=template&id=50dd5424&scoped=true"
import script from "./DrugQueue.vue?vue&type=script&lang=js"
export * from "./DrugQueue.vue?vue&type=script&lang=js"
import style0 from "./DrugQueue.vue?vue&type=style&index=0&id=50dd5424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dd5424",
  null
  
)

export default component.exports